export const formatAddress = (wallet: string) => {
  if (wallet)
    return wallet.substring(0, 6) + '...' + wallet.substring(wallet.length - 4)
  return ''
}

export const extractId = (field: any): string | undefined => {
  if (!field) return undefined
  if (typeof field === 'string') return field
  if (typeof field === 'object' && field._id) return String(field._id)
  return undefined
}

export * from './subdomain'
